import {
  formatPurchasePlanningCurrency,
  formatPurchasePlanningCashRequired,
  formatPurchasePlanningNumber,
} from '../../../lib/purchasePlanningHelpers';

export function InventoryCapitalPlanMainTable({ rows }) {
  return (
    <div className="overflow-hidden rounded-lg border border-gray-200 bg-white">
      <div className="max-h-[calc(100vh-18rem)] overflow-auto">
        <table className="min-w-full text-left text-sm">
          <thead className="sticky top-0 z-10 bg-slate-50 text-xs uppercase tracking-[0.12em] text-gray-500">
            <tr>
              <th className="px-4 py-3 font-medium">Category</th>
              <th className="px-4 py-3 font-medium">Product / SKU</th>
              <th className="px-4 py-3 font-medium">Supplier</th>
              <th className="px-4 py-3 font-medium">PO window</th>
              <th className="px-4 py-3 font-medium">Next PO required</th>
              <th className="px-4 py-3 text-right font-medium">Adjusted rounded units</th>
              <th className="px-4 py-3 text-right font-medium">Unit cost</th>
              <th className="px-4 py-3 text-right font-medium">Cash required</th>
              <th className="px-4 py-3 font-medium">Notes</th>
            </tr>
          </thead>
          <tbody>
            {rows.length > 0 ? (
              rows.map(row => {
                const missingCost = row.unitCost <= 0;
                const unscheduled = !row.nextPoRequiredDate;
                return (
                  <tr key={row.id} className="border-b border-gray-100 hover:bg-gray-50">
                    <td className="px-4 py-3 align-top text-gray-600">
                      <p className="font-medium text-gray-900">{row.category}</p>
                      <p className="mt-1 text-xs text-gray-500">{row.subCategory}</p>
                    </td>
                    <td className="px-4 py-3 align-top text-gray-600">
                      <p className="font-medium text-gray-900">{row.productName}</p>
                      <p className="mt-1 text-xs text-gray-500">{row.supplySku}</p>
                    </td>
                    <td className="px-4 py-3 align-top text-gray-600">{row.supplier}</td>
                    <td className="px-4 py-3 align-top text-gray-600">
                      {row.orderMonth || row.month || 'Unscheduled'}
                    </td>
                    <td className="px-4 py-3 align-top text-gray-600">
                      {row.nextPoRequiredDate || 'Not scheduled'}
                    </td>
                    <td className="px-4 py-3 text-right align-top tabular-nums font-medium text-gray-900">
                      {formatPurchasePlanningNumber(row.adjustedRoundedUnits)}
                    </td>
                    <td className="px-4 py-3 text-right align-top tabular-nums text-gray-900">
                      {formatPurchasePlanningCurrency(row.unitCost)}
                    </td>
                    <td className="px-4 py-3 text-right align-top tabular-nums font-semibold text-gray-900">
                      {formatPurchasePlanningCashRequired(row.cashRequired)}
                    </td>
                    <td className="px-4 py-3 align-top text-gray-600">
                      <div className="flex flex-wrap gap-1.5">
                        <span
                          className={`inline-flex rounded-md px-2 py-1 text-[11px] font-medium ${
                            missingCost ? 'bg-red-100 text-red-700' : 'bg-slate-100 text-slate-700'
                          }`}
                        >
                          {missingCost ? 'Cost master required' : 'Cost master linked'}
                        </span>
                        <span
                          className={`inline-flex rounded-md px-2 py-1 text-[11px] font-medium ${
                            unscheduled ? 'bg-amber-100 text-amber-700' : 'bg-slate-100 text-slate-700'
                          }`}
                        >
                          {unscheduled ? 'PO date missing' : 'PO date set'}
                        </span>
                        {row.exceptionTypes.includes('underfilled-container') ? (
                          <span className="inline-flex rounded-md bg-slate-100 px-2 py-1 text-[11px] font-medium text-slate-700">
                            Container fill uplift
                          </span>
                        ) : null}
                      </div>
                      <p className="mt-2 text-xs text-gray-500">
                        Cash required = {formatPurchasePlanningNumber(row.adjustedRoundedUnits)} ×{' '}
                        {formatPurchasePlanningCurrency(row.unitCost)}
                      </p>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td className="px-4 py-8 text-sm text-gray-500" colSpan={9}>
                  No inventory-capital rows match the current filters.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
